<div class="modal-header">
    <h4 class="modal-title fw-bold word-wrap"><span jhiTranslate="germplasm-details.graphviz.modal.title">Pedigree Graph</span></h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="clear()">
    </button>
</div>
<div class="container-fluid ps-0 pe-0">
	<div class="modal-body" style="width: 90vw">
		<jhi-pedigree-graph [gid]="gid"></jhi-pedigree-graph>
	</div>
</div>

